import React from "react";
import moment from "moment";
import { storage } from "../../../dependencies/store/storage";
import { ROLES } from "../../../constants/role";

const TableColumn = ({ pageNo = 0, size = 10 }) => {
  const role = storage.getUserRole();
  return [
    {
      dataField: "",
      text: "S.No",
      formatter: (cell, row, rowIndex) => {
        return pageNo * size + (rowIndex + 1);
      },
    },
    {
      dataField: "timestamp",
      text: "Date & Time",
      formatter: (cell, row, rowIndex) => {
        return moment(cell).format("DD/MM/YYYY h:mm:ss a");
      },
    },
    {
      dataField: "type",
      text: "Type",
      sort: false,
      formatter: (cell, row) => {
        const capitalizedType = cell.charAt(0).toUpperCase() + cell.slice(1);
        return capitalizedType;
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (cell, row, rowIndex) => {
        return cell;
      },
    },
    {
      dataField: "remainingBalance",
      text: "Balance",
      formatter: (cell, row, rowIndex) => {
        return cell;
      },
    },
    {
      dataField: "message",
      text: "Description",
      formatter: (cell, row, rowIndex) => {
        if (row.type === 'debit') {
          return (<span className="text-danger">{cell}</span>)
        } else {
          return (<span className="text-success">{cell}</span>)
        }
      },
    },
    {
      dataField: "_id",
      text: "Invoice",
      hidden: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <a className="btn btn-sm btn-warning" href="#0">Invoices</a>
        )
      },
    },
  ];
};

export default TableColumn;
